import styled, { css } from 'styled-components'
import { Video } from '@/molecules/Video/styles'

export const VideoSection = styled.div`
  max-height: 700px;
  margin-bottom: ${({ theme }) => theme.rem(24)};

  ${Video} {
    border-radius: 16px;
    overflow: hidden;
  }
`
